import React, {useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";
import IconCustom from "../../../../Utils/IconCustom/IconCustom";
import {Tooltip} from "@material-ui/core";
import {multiLanguageValue} from "../../Utils/lib";
import {useSelector} from "react-redux";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";

const IconComponent = ({component, actionsContext, ...props}) => {
    const [resolvedIcon, setResolvedIcon] = useState('')
    const [actions, setActions] = useState(null)
    const globalValues = useSelector(state => state.jsonScreen.globalValues);
    const {styles: sourceStyles, properties: {icon, iconType, tooltip, hideCondition} = {}} = component;
    const styles = sourceStyles && sourceStyles.length ? sourceStyles[0] : {};
    const userLanguage = useSelector(state => state.app.userLanguage);

    const isHidden = useMemo(() => {
        return checkHidden({...globalValues, ...actionsContext}, hideCondition, props.screenName);
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext), hideCondition, props.screenName])

    const tooltipText = useMemo(() => {
        return getParamsFromString(multiLanguageValue(tooltip, userLanguage), {...globalValues, ...actionsContext}, props.screenName)
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext), tooltip, props.screenName, userLanguage])

    useEffect(() => {
        const getIcon = getParamsFromString(icon, {...props.globalValues, ...actionsContext}, props.screenName);
        setResolvedIcon(getIcon)
        if (component.events && component.events[0].event === 'onClick') {
            setActions(component.events[0].actions)
        }
    }, [icon, JSON.stringify(props.globalValues), JSON.stringify(actionsContext)])

    function onClick() {
        const {doActions, actionsContext} = props;
        if (actions) {
            doActions(actions, actionsContext);
        }
    }

    if (isHidden) return <></>

    return (
        <Tooltip title={tooltipText}>
            <IconCustom
                iconType={iconType}
                onClick={onClick}
                style={{...styles, cursor: actions ? 'pointer' : ''}}>
                {resolvedIcon}
            </IconCustom>
        </Tooltip>
    )
};

export default JsonScreenHoc(IconComponent);

IconComponent.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.shape({
            icon: PropTypes.string,
            iconType: PropTypes.oneOf(['outlined', 'regular', 'symbols-outlined', 'symbols-rounded'])
        })
    }),
    globalValues: PropTypes.object,
    actionsContext: PropTypes.object,
    screenName: PropTypes.string
}